import { FormControl, FormField, FormItem, FormMessage, Switch } from "@/shared/components";
import { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";

interface SwitchFormFieldProps<T extends FieldValues> {
    form: UseFormReturn<T>;
    label?: string;
    name: FieldPath<T>;
    className?: string;
    readOnly?: boolean;
}

export function SwitchFormfield<T extends FieldValues>({ form, label, name, className, readOnly }: Readonly<SwitchFormFieldProps<T>>) {
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    <FormControl>
                        <Switch checked={field.value} onCheckedChange={field.onChange} disabled={readOnly} label={label} {...field} />
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
